module.exports = __webpack_public_path__ + "img/icon-closed-header.e7292667.png";